import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { SuggestionOption } from '@/types/reader'
import { uniqBy } from '@/helpers/uniqBy'

interface State {
    source: SuggestionOption | null
    history: SuggestionOption[]
}

interface Actions {
    setOption: (source: SuggestionOption) => void
    setHistory: (source: SuggestionOption) => void
    clearSource: () => void
}

export const useReaderLogStore = create<State & Actions>()(
    persist(
        (set) => ({
            source: null,
            history: [],
            setOption: (source: SuggestionOption) => set({ source }),
            setHistory: (source: SuggestionOption) =>
                set((state) => {
                    if (!state.history.length) {
                        return {
                            ...state,
                            history: [source],
                        }
                    }

                    const alreadyInHistory = state.history.find((item) => item.title === source.title)

                    if (alreadyInHistory) {
                        return state
                    }

                    if (state.history.length < 3) {
                        return {
                            ...state,
                            history: uniqBy([source, ...state.history], 'title'),
                        }
                    }

                    return {
                        ...state,
                        history: uniqBy([...state.history.slice(1), source], 'title'),
                    }
                }),
            clearSource: () => set({ source: null }),
        }),
        {
            name: 'reader-log-storage',
        }
    )
)
